import { t } from "i18next";

import {
  Alert,
  type AlertColor,
  AlertTitle,
  type SxProps,
  type Theme,
  Typography
} from "@mui/material";

import { toSxArray } from "@/src/utils/sx";

import { type TargetPriceStatus } from "./targetPriceStatus";

export interface TargetPriceAlertProps {
  status: TargetPriceStatus;
  title?: string;
  description?: string;
  sx?: SxProps<Theme>;
}

const STATUS_SEVERITY: Record<TargetPriceStatus, AlertColor> = {
  within: "success",
  below: "info",
  above: "warning"
};

const TargetPriceAlert = ({
  status,
  title,
  description,
  sx
}: TargetPriceAlertProps) => {
  const resolvedTitle =
    title ?? t(`components.targetPriceAlert.${status}.title`);
  const resolvedDescription =
    description ?? t(`components.targetPriceAlert.${status}.body`);

  const severity = STATUS_SEVERITY[status];

  return (
    <Alert severity={severity} sx={toSxArray(sx)}>
      <AlertTitle
        sx={{
          fontWeight: "fontWeightBold",
          mb: 0.5
        }}
      >
        {resolvedTitle}
      </AlertTitle>
      <Typography variant="body2">{resolvedDescription}</Typography>
    </Alert>
  );
};

export default TargetPriceAlert;
